'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _size = require('@react-hook/size');

var _size2 = _interopRequireDefault(_size);

var _dotstatsuiteVisions = require('@sis-cc/dotstatsuite-visions');

var _styles = require('@mui/styles');

var _options = require('./chartUtils/options');

var _options2 = _interopRequireDefault(_options);

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

var _chart = require('./chart');

var _chart2 = _interopRequireDefault(_chart);

var _footer = require('./footer');

var _footer2 = _interopRequireDefault(_footer);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      borderColor: '#007bc7',
      borderBottomWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 1,
      borderRightWidth: 0,
      borderStyle: 'solid',
      '& svg text::selection': {
        background: 'none'
      }
    },
    tableContainer: {
      minWidth: '100%',
      minHeight: '100%',
      willChange: 'transform, opacity'
    },
    chartContainer: {
      width: function width(_ref) {
        var fixedWidth = _ref.fixedWidth;
        return fixedWidth || '100%';
      },
      height: function height(_ref2) {
        var fixedHeight = _ref2.fixedHeight;
        return fixedHeight || '100%';
      },
      overflow: 'hidden',
      position: 'relative'
    }
  };
});

var ViewContent = function ViewContent(_ref3) {
  var loading = _ref3.loading,
      _ref3$loadingProps = _ref3.loadingProps,
      loadingProps = _ref3$loadingProps === undefined ? {} : _ref3$loadingProps,
      type = _ref3.type,
      width = _ref3.width,
      errorMessage = _ref3.errorMessage,
      rest = (0, _objectWithoutProperties3.default)(_ref3, ['loading', 'loadingProps', 'type', 'width', 'errorMessage']);

  if (loading) return _react2.default.createElement(_dotstatsuiteVisions.Loading, (0, _extends3.default)({ message: loading }, loadingProps));
  if (errorMessage) return _react2.default.createElement(_dotstatsuiteVisions.NoData, { message: errorMessage });

  if (type === 'table') {
    var tableProps = R.propOr({}, 'tableProps', rest);
    var hasNoObs = R.pipe(R.prop('cells'), R.anyPass([R.isNil, R.isEmpty]))(tableProps);
    if (hasNoObs) return _react2.default.createElement(_dotstatsuiteVisions.Loading, null);

    return _react2.default.createElement(_dotstatsuiteVisions.TableHtml5, (0, _extends3.default)({ isRtl: R.prop('isRtl', rest) }, tableProps));
  }
  if ((0, _utils.isChartDataNotReady)({ data: R.prop('chartData', rest) }) || !width) {
    return _react2.default.createElement(_dotstatsuiteVisions.Loading, null);
  }
  return _react2.default.createElement(_chart2.default, {
    data: R.prop('chartData', rest),
    getAxisOptions: R.prop('getAxisOptions', rest),
    heightOffsets: R.prop('heightOffsets', rest),
    options: R.prop('chartOptions', rest),
    type: type,
    width: width
  });
};

var Viewer = function Viewer(_ref4) {
  var _cx;

  var type = _ref4.type,
      _ref4$targets = _ref4.targets,
      targets = _ref4$targets === undefined ? {} : _ref4$targets,
      width = _ref4.width,
      rest = (0, _objectWithoutProperties3.default)(_ref4, ['type', 'targets', 'width']);

  var classes = useStyles({
    fixedWidth: rest.fixedWidth,
    fixedHeight: rest.fixedHeight
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, targets.viewer ? { ref: targets.viewer } : {}, {
      className: (0, _classnames2.default)(classes.container, (_cx = {}, (0, _defineProperty3.default)(_cx, classes.tableContainer, type === 'table'), (0, _defineProperty3.default)(_cx, classes.chartContainer, type !== 'table'), _cx))
    }),
    _react2.default.createElement(_header2.default, (0, _extends3.default)({
      target: targets.header
    }, R.propOr({}, 'headerProps', rest))),
    _react2.default.createElement(ViewContent, (0, _extends3.default)({ type: type, width: width }, rest)),
    _react2.default.createElement(_footer2.default, (0, _extends3.default)({
      width: width,
      target: targets.footer,
      type: type,
      chartData: R.prop('chartData', rest),
      chartOptions: R.prop('chartOptions', rest)
    }, R.prop('footerProps', rest)))
  );
};

var defaultChartHeight = function defaultChartHeight(chartOptions) {
  return R.pipe(R.path(['base', 'height']), function (h) {
    return R.isNil(h) || isNaN(h) ? 0 : h;
  })(chartOptions);
};

var ViewerWrapper = function ViewerWrapper(_ref5) {
  var chartOptions = _ref5.chartOptions,
      type = _ref5.type,
      getResponsiveSize = _ref5.getResponsiveSize,
      props = (0, _objectWithoutProperties3.default)(_ref5, ['chartOptions', 'type', 'getResponsiveSize']);

  var theme = (0, _styles.useTheme)();
  var viewerTarget = _react2.default.useRef(null);
  var headerTarget = _react2.default.useRef(null);
  var footerTarget = _react2.default.useRef(null);

  var _useSize = (0, _size2.default)(viewerTarget),
      _useSize2 = (0, _slicedToArray3.default)(_useSize, 2),
      viewerWidth = _useSize2[0],
      viewerHeight = _useSize2[1];

  var _useSize3 = (0, _size2.default)(headerTarget, { initialHeight: -1 }),
      _useSize4 = (0, _slicedToArray3.default)(_useSize3, 2),
      _ = _useSize4[0],
      headerHeight = _useSize4[1];

  var _useSize5 = (0, _size2.default)(footerTarget, { initialHeight: -1 }),
      _useSize6 = (0, _slicedToArray3.default)(_useSize5, 2),
      ___ = _useSize6[0],
      footerHeight = _useSize6[1];

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      chartSvgHeight = _useState2[0],
      setChartSvgHeight = _useState2[1];

  var defChartHeight = defaultChartHeight(chartOptions);

  (0, _react.useEffect)(function () {
    if (R.is(Function, getResponsiveSize) && viewerWidth && headerHeight !== -1 && footerHeight !== -1) {
      getResponsiveSize({
        responsiveWidth: viewerWidth,
        responsiveHeight: viewerHeight
      });
    }
  }, [viewerWidth, viewerHeight]);

  (0, _react.useEffect)(function () {
    if (headerHeight !== -1 && footerHeight !== -1 && !isNaN(headerHeight) && !isNaN(footerHeight)) {
      var nextHeight = defChartHeight - headerHeight - footerHeight - 2;
      setChartSvgHeight(nextHeight);
    }
  }, [headerHeight, footerHeight, defChartHeight]);

  if (type === 'table') {
    return _react2.default.createElement(Viewer, (0, _extends3.default)({}, props, {
      width: viewerWidth,
      type: type
    }));
  }

  var preparedChartOptions = R.pipe(R.over(R.lensPath(['base', 'width']), R.when(R.anyPass([R.isNil, isNaN]), R.always(viewerWidth || 0))), R.set(R.lensPath(['base', 'height']), chartSvgHeight), function (chartOptions) {
    return (0, _options2.default)(chartOptions, props.chartData, type, theme, props.timeFormats, props.locale);
  })(chartOptions);

  return _react2.default.createElement(Viewer, (0, _extends3.default)({}, props, {
    type: type,
    chartOptions: preparedChartOptions,
    fixedWidth: R.path(['base', 'width'], chartOptions),
    fixedHeight: defChartHeight,
    targets: {
      viewer: viewerTarget,
      header: headerTarget,
      footer: footerTarget
    },
    width: viewerWidth
  }));
};

exports.default = ViewerWrapper;